import Reveal from "./Reveal";
import RobotMascot from "./RobotMascot";
import { IMAGES } from "../content";

const CHAPTERS = [
  {
    n: "01",
    title: "Tell the robot your plan",
    body: "Five fields. Three minutes. No documents to upload, no branch to visit, nothing to fax to a stranger.",
    tag: "Apply · 3 min",
  },
  {
    n: "02",
    title: "The engine reads your file",
    body: "Our underwriting robot scores your application in seconds with a soft credit check that never dents your score.",
    tag: "Decision · 60 sec",
    robot: true,
  },
  {
    n: "03",
    title: "Money lands",
    body: "e-Sign your offer and funds transfer the same business day. Track every step in your dashboard, in plain English.",
    tag: "Funding · same day",
  },
];

const HowItWorks = () => (
  <section id="how" data-testid="how-it-works" className="relative py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <p className="label-mono text-[#007AFF] mb-4">How it works</p>
        <h2 className="font-display font-bold tracking-[-0.02em] leading-[1.02] text-[#0A1628] text-4xl md:text-6xl max-w-2xl">
          Three steps.<br />Zero paperwork.
        </h2>
      </Reveal>

      <div className="mt-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal className="relative rounded-[2rem] overflow-hidden border border-black/5 bg-white shadow-[0_8px_32px_rgba(0,0,0,0.05)]">
              <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#00E5FF]/15 to-transparent" aria-hidden="true" />
              <img
                data-testid="how-robot-img"
                src={IMAGES.review}
                alt="The LendRobot reviewing an application"
                className="w-full h-[380px] md:h-[460px] object-cover object-center"                draggable="false"
              />
              <div className="flex items-center justify-between px-6 py-4 border-t border-black/5">
                <span className="label-mono text-[#52525B]">Robo-B7 · Underwriting unit</span>
                <span className="flex items-center gap-2 label-mono text-[#14D8A5]">
                  <span className="h-2 w-2 rounded-full bg-[#14D8A5] animate-pulse" /> Reading
                </span>
              </div>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08} className="group border-t border-black/8 py-10 md:py-14 first:border-t-0 first:pt-2 lg:first:pt-14">
              <div className="flex items-start gap-6 md:gap-10">
                <span className="font-display text-6xl md:text-8xl font-bold text-outline leading-none select-none">
                  {c.n}
                </span>
                <div>
                  <div className="flex items-center gap-3 flex-wrap">
                    <h3 className="font-display text-2xl md:text-3xl font-bold text-[#0A1628]">{c.title}</h3>
                    {c.robot && (
                      <span className="lr-float-slow hidden sm:block">
                        <RobotMascot className="w-10" />
                      </span>
                    )}
                  </div>
                  <p className="mt-4 max-w-md text-base leading-relaxed text-[#52525B]">{c.body}</p>
                  <p className="label-mono mt-5 inline-block rounded-full border border-black/10 px-4 py-1.5 text-[#007AFF]">
                    {c.tag}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
